export const getHexValue = (value?: number | string) => {
  if (value || value === 0) {
    const hexValue = value.toString(16).toUpperCase();
    let strOfZeros = '';
    for (let i = 0; i < 4 - hexValue.length; ++i) {
      strOfZeros += '0';
    }
    return strOfZeros + hexValue;
  }
  return value;
};
